export default {
  URL: process.env.REACT_APP_URL_PAYMENT || 'https://payment-gateway.develop.embrix.org/vault?callbackUrl='
};
